var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sales-report__wrapper" }, [
    _c(
      "div",
      {
        staticClass:
          "css-grid sales-report__header sales-report__header--transactions"
      },
      [
        _c("div", { staticClass: "sales-report__header-name" }, [
          _vm._v(
            _vm._s(
              _vm.decode(_vm.entityData.name) || _vm.title || "(Unmatched)"
            )
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "sales-report__header-transactions",
            attrs: { title: "Download transactions for this data" },
            on: { click: _vm.downloadTransactions }
          },
          [
            _c("span", {
              staticClass:
                "sales-report__header-transactions-icon glyphicon glyphicon-circle-arrow-down",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v("\n        Transactions\n    ")
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "css-grid sales-report__body" }, [
      _c("div", { staticClass: "css-grid sales-report__sidebar" }, [
        _c("div", { staticClass: "css-grid sales-report-sidebar__category" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "sales-report-sidebar__category-box" }, [
            _c(
              "div",
              { staticClass: "sales-report-sidebar__category-subtitle" },
              [_vm._v("Active")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sales-report-sidebar__category-number" },
              [_vm._v(_vm._s(this.currency(_vm.totals.units)))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sales-report-sidebar__category-box" }, [
            _c(
              "div",
              { staticClass: "sales-report-sidebar__category-subtitle" },
              [_vm._v("Runrate")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sales-report-sidebar__category-number" },
              [_vm._v(_vm._s(this.currency(_vm.totals.est_units)))]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sales-report-sidebar__category-box",
              attrs: {
                "data-toggle": "tooltip",
                title:
                  "Runrate vs. Prior " + this.currency(_vm.totals.yoy_units)
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "sales-report-sidebar__category-number sales-report-sidebar__category-number--only",
                  class: [
                    _vm.getChangePercent(
                      _vm.totals.est_units,
                      _vm.totals.yoy_units
                    ) >= 0
                      ? "sales-report-sidebar__category-number--positive"
                      : "sales-report-sidebar__category-number--negative"
                  ]
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.getChangePercent(
                          _vm.totals.est_units,
                          _vm.totals.yoy_units
                        )
                      ) +
                      "%\n          "
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid sales-report-sidebar__category" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "sales-report-sidebar__category-box" }, [
            _c(
              "div",
              { staticClass: "sales-report-sidebar__category-subtitle" },
              [_vm._v("Active")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sales-report-sidebar__category-number" },
              [_vm._v("$" + _vm._s(this.currency(_vm.totals.sales)))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sales-report-sidebar__category-box" }, [
            _c(
              "div",
              { staticClass: "sales-report-sidebar__category-subtitle" },
              [_vm._v("Runrate")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sales-report-sidebar__category-number" },
              [_vm._v("$" + _vm._s(this.currency(_vm.totals.est_sales)))]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sales-report-sidebar__category-box",
              attrs: {
                "data-toggle": "tooltip",
                title:
                  "Runrate vs. Prior $" + this.currency(_vm.totals.yoy_sales)
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "sales-report-sidebar__category-number sales-report-sidebar__category-number--only",
                  class: [
                    _vm.getChangePercent(
                      _vm.totals.est_sales,
                      _vm.totals.yoy_sales
                    ) >= 0
                      ? "sales-report-sidebar__category-number--positive"
                      : "sales-report-sidebar__category-number--negative"
                  ]
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.getChangePercent(
                          _vm.totals.est_sales,
                          _vm.totals.yoy_sales
                        )
                      ) +
                      "%\n          "
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid sales-report-sidebar__category" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "sales-report-sidebar__category-box" }, [
            _c(
              "div",
              { staticClass: "sales-report-sidebar__category-subtitle" },
              [_vm._v("Active")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sales-report-sidebar__category-number" },
              [
                _vm._v(
                  "$" +
                    _vm._s(
                      this.currency(
                        _vm.divide(_vm.totals.sales, _vm.totals.units)
                      )
                    )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sales-report-sidebar__category-box" }, [
            _c(
              "div",
              { staticClass: "sales-report-sidebar__category-subtitle" },
              [_vm._v("Prior")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sales-report-sidebar__category-number" },
              [
                _vm._v(
                  "$" +
                    _vm._s(
                      this.currency(
                        _vm.divide(_vm.totals.yoy_sales, _vm.totals.yoy_units)
                      )
                    )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sales-report-sidebar__category-box" }, [
            _c(
              "div",
              {
                staticClass:
                  "sales-report-sidebar__category-number sales-report-sidebar__category-number--only",
                class: [
                  _vm.getChangePercent(
                    _vm.divide(_vm.totals.sales, _vm.totals.units),
                    _vm.divide(_vm.totals.yoy_sales, _vm.totals.yoy_units)
                  ) >= 0
                    ? "sales-report-sidebar__category-number--positive"
                    : "sales-report-sidebar__category-number--negative"
                ]
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getChangePercent(
                        _vm.divide(_vm.totals.sales, _vm.totals.units),
                        _vm.divide(_vm.totals.yoy_sales, _vm.totals.yoy_units)
                      )
                    ) +
                    "%\n          "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(3)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sales-report__main" }, [
        _c(
          "div",
          {
            staticClass: "sales-report__tab-body",
            class: [{ "sales-report__tab-body--empty": _vm.currentTab === "" }]
          },
          [
            _c("MixSales", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentTab == "MixSales",
                  expression: "currentTab == 'MixSales'"
                }
              ],
              attrs: {
                "entity-data": _vm.entityData,
                filters: _vm.localFilterString
              }
            }),
            _vm._v(" "),
            _c("TrendSales", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentTab == "TrendSales",
                  expression: "currentTab == 'TrendSales'"
                }
              ],
              attrs: {
                "show-trend": _vm.showTrend,
                "formatted-data": _vm.formattedSalesData
              }
            }),
            _vm._v(" "),
            _vm.currentTab == "TrendUnits"
              ? _c("TrendUnits", {
                  attrs: {
                    "show-trend": _vm.showTrend,
                    "formatted-data": _vm.formattedUnitsData
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.currentTab == "TrendVendors"
              ? _c("TrendVendors", {
                  attrs: {
                    "show-trend": _vm.showTrend,
                    "formatted-data": _vm.formattedVendorsData
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.currentTab == "TopProducts"
              ? _c("TopProducts", {
                  attrs: {
                    "show-trend": _vm.showTrend,
                    "formatted-data": _vm.formattedProductData
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "css-grid sales-report__footer" },
      [
        _c("SalesDetails", {
          attrs: { months: _vm.trendData, show: _vm.displayDetails }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "sales-report__footer--more" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showTrend,
                  expression: "showTrend"
                }
              ],
              staticClass: "sales-report__footer-expandable",
              on: { click: _vm.toggleDetails }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.displayDetails
                    ? "- Hide sales details"
                    : "+ Show sales details"
                )
              )
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sales-report-sidebar__category-box" }, [
      _c("div", { staticClass: "sales-report-sidebar__category-title" }, [
        _vm._v("UNITS")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sales-report-sidebar__category-box" }, [
      _c("div", { staticClass: "sales-report-sidebar__category-title" }, [
        _vm._v("SALES")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sales-report-sidebar__category-box" }, [
      _c("div", { staticClass: "sales-report-sidebar__category-title" }, [
        _vm._v("ASP")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "css-grid sales-report-sidebar__category sales-report-sidebar__category--fuel-time"
      },
      [
        _c("div", { staticClass: "sales-report-sidebar__category-box" }, [
          _c(
            "div",
            {
              staticClass:
                "sales-report-sidebar__category-title sales-report-sidebar__category-title--fuel-time"
            },
            [_vm._v(" ")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sales-report-sidebar__category-box" }, [
          _c("div", { staticClass: "sales-report-sidebar__category-number" }, [
            _vm._v(" ")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }